import { render } from "./EinstellungenModalComponent.vue?vue&type=template&id=6c1e22ac"
import script from "./EinstellungenModalComponent.vue?vue&type=script&lang=js"
export * from "./EinstellungenModalComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__